(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ==========================================================
     STICKY HEADER
  ========================================================== */

  class BavlyMobileStickyHeader extends HTMLElement {

    connectedCallback() {

      this.section =
        this.closest('.section-header') ||
        document.querySelector('.section-header');


      if (!this.section) {
        return;
      }


      this.alwaysSticky =
        this.getAttribute(
          'data-sticky-type'
        ) === 'always';


      this.headerBounds = {};

      this.currentScrollTop = 0;

      this.preventReveal = false;


      this.boundResize =
        this.setHeaderHeight.bind(this);


      this.boundScroll =
        this.onScroll.bind(this);


      this.preventRevealHandler =
        () => {
          this.preventReveal = true;
        };


      this.setHeaderHeight();


      window.addEventListener(
        'resize',
        this.boundResize
      );


      window.addEventListener(
        'scroll',
        this.boundScroll,
        false
      );


      this.addEventListener(
        'preventHeaderReveal',
        this.preventRevealHandler
      );


      if (this.alwaysSticky) {

        this.section.classList.add(
          'shopify-section-header-sticky'
        );

      }


      this.createObserver();

    }


    setHeaderHeight() {

      if (!this.section) {
        return;
      }


      document.documentElement.style.setProperty(
        '--header-height',
        `${this.section.offsetHeight}px`
      );

    }


    createObserver() {

      const observer =
        new IntersectionObserver(
          (entries, activeObserver) => {

            this.headerBounds =
              entries[0].intersectionRect;


            activeObserver.disconnect();

          }
        );


      observer.observe(
        this.section
      );

    }


    onScroll() {

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;


      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.section.classList.add(
          'scrolled-past-header'
        );


        if (!this.alwaysSticky) {

          requestAnimationFrame(
            this.hide.bind(this)
          );

        }

      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {

        this.section.classList.add(
          'scrolled-past-header'
        );


        if (!this.preventReveal) {

          requestAnimationFrame(
            this.reveal.bind(this)
          );

        }

      } else if (
        scrollTop <= this.headerBounds.top
      ) {

        this.section.classList.remove(
          'scrolled-past-header'
        );


        requestAnimationFrame(
          this.reset.bind(this)
        );

      }


      this.currentScrollTop =
        scrollTop;

    }


    hide() {

      if (this.alwaysSticky) {
        return;
      }


      this.section.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

    }


    reveal() {

      if (this.alwaysSticky) {
        return;
      }


      this.section.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );


      this.section.classList.remove(
        'shopify-section-header-hidden'
      );

    }


    reset() {

      if (this.alwaysSticky) {
        return;
      }


      this.section.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

    }


    disconnectedCallback() {

      window.removeEventListener(
        'resize',
        this.boundResize
      );


      window.removeEventListener(
        'scroll',
        this.boundScroll
      );


      this.removeEventListener(
        'preventHeaderReveal',
        this.preventRevealHandler
      );

    }

  }


  if (!customElements.get('sticky-header')) {

    customElements.define(
      'sticky-header',
      BavlyMobileStickyHeader
    );

  }



  /* ==========================================================
     DYNAMIC DEPARTMENTS
  ========================================================== */

  (function () {

    const STORAGE_KEY =
      'bavly-selected-department';


    const PARAMETER_NAME =
      'department';


    function getDepartmentTabs() {

      return Array.from(
        document.querySelectorAll(
          '[data-bavly-department-tab]'
        )
      );

    }


    function getAllowedDepartments() {

      return getDepartmentTabs()

        .map(function (tab) {

          return String(
            tab.getAttribute(
              'data-bavly-department-tab'
            ) || ''
          )
            .toLowerCase()
            .trim();

        })

        .filter(Boolean);

    }


    function getDefaultDepartment() {

      const allowed =
        getAllowedDepartments();


      return (
        allowed[0] ||
        'women'
      );

    }


    function normalizeDepartment(value) {

      const allowed =
        getAllowedDepartments();


      const fallback =
        getDefaultDepartment();


      value =
        String(value || '')
          .toLowerCase()
          .trim();


      if (
        allowed.includes(value)
      ) {

        return value;

      }


      return fallback;

    }


    function isHomePage() {

      const path =
        window.location.pathname
          .replace(/\/$/, '');


      return (
        path === '' ||
        path === '/'
      );

    }


    function getDepartmentFromUrl() {

      const params =
        new URLSearchParams(
          window.location.search
        );


      const value =
        params.get(
          PARAMETER_NAME
        );


      if (!value) {
        return null;
      }


      const normalized =
        String(value)
          .toLowerCase()
          .trim();


      if (
        getAllowedDepartments()
          .includes(normalized)
      ) {

        return normalized;

      }


      return null;

    }


    function getSavedDepartment() {

      try {

        const value =
          window.localStorage.getItem(
            STORAGE_KEY
          );


        if (!value) {
          return null;
        }


        const normalized =
          String(value)
            .toLowerCase()
            .trim();


        if (
          getAllowedDepartments()
            .includes(normalized)
        ) {

          return normalized;

        }

      } catch (error) {
      }


      return null;

    }


    function saveDepartment(
      department
    ) {

      try {

        window.localStorage.setItem(
          STORAGE_KEY,
          department
        );

      } catch (error) {
      }

    }


    function updateUrl(
      department
    ) {

      if (!isHomePage()) {
        return;
      }


      const url =
        new URL(
          window.location.href
        );


      const defaultDepartment =
        getDefaultDepartment();


      if (
        department ===
        defaultDepartment
      ) {

        url.searchParams.delete(
          PARAMETER_NAME
        );

      } else {

        url.searchParams.set(
          PARAMETER_NAME,
          department
        );

      }


      window.history.replaceState(
        {},
        '',
        url.toString()
      );

    }


    function getDepartmentLabel(
      department
    ) {

      const tab =
        getDepartmentTabs()
          .find(function (item) {

            return String(
              item.getAttribute(
                'data-bavly-department-tab'
              ) || ''
            )
              .toLowerCase()
              .trim() === department;

          });


      return tab
        ? tab.textContent.trim()
        : department;

    }


    function setActiveNavigation(
      department
    ) {

      getDepartmentTabs()
        .forEach(function (link) {

          const linkDepartment =
            String(
              link.getAttribute(
                'data-bavly-department-tab'
              ) || ''
            )
              .toLowerCase()
              .trim();


          const active =
            linkDepartment ===
            department;


          link.classList.toggle(
            'is-active',
            active
          );


          if (active) {

            link.setAttribute(
              'aria-current',
              'page'
            );

          } else {

            link.removeAttribute(
              'aria-current'
            );

          }

        });


      document
        .querySelectorAll(
          '[data-bavly-drawer-department]'
        )
        .forEach(function (button) {

          const buttonDepartment =
            String(
              button.getAttribute(
                'data-bavly-drawer-department'
              ) || ''
            )
              .toLowerCase()
              .trim();


          button.classList.toggle(
            'is-active',
            buttonDepartment ===
            department
          );

        });

    }


    function updateDrawerCategories(
      department
    ) {

      const groups =
        document.querySelectorAll(
          '[data-bavly-menu-group]'
        );


      let visibleGroup = null;


      groups.forEach(
        function (group) {

          const groupDepartment =
            String(
              group.getAttribute(
                'data-bavly-menu-group'
              ) || ''
            )
              .toLowerCase()
              .trim();


          const active =
            groupDepartment ===
            department;


          group.classList.toggle(
            'is-active',
            active
          );


          if (active) {
            visibleGroup = group;
          }

        }
      );


      const empty =
        document.querySelector(
          '[data-bavly-menu-empty]'
        );


      if (empty) {

        empty.classList.toggle(
          'is-visible',
          !visibleGroup
        );

      }


      const title =
        document.querySelector(
          '[data-bavly-menu-title]'
        );


      if (title) {

        title.textContent =
          getDepartmentLabel(
            department
          ) + ' Categories';

      }

    }


    function broadcastDepartmentChange(
      department
    ) {

      document.documentElement
        .setAttribute(
          'data-bavly-department',
          department
        );


      if (document.body) {

        document.body
          .setAttribute(
            'data-bavly-department',
            department
          );

      }


      window.dispatchEvent(
        new CustomEvent(
          'bavly:department-change',
          {
            detail: {
              department:
                department
            }
          }
        )
      );

    }


    function changeDepartment(
      department,
      shouldUpdateUrl
    ) {

      department =
        normalizeDepartment(
          department
        );


      saveDepartment(
        department
      );


      setActiveNavigation(
        department
      );


      updateDrawerCategories(
        department
      );


      if (
        shouldUpdateUrl !== false
      ) {

        updateUrl(
          department
        );

      }


      broadcastDepartmentChange(
        department
      );

    }


    function getInitialDepartment() {

      const urlDepartment =
        getDepartmentFromUrl();


      if (urlDepartment) {

        return urlDepartment;

      }


      /*
        Home page always starts with Women.
        We intentionally do not restore the previously saved department.
      */

      if (isHomePage()) {

        const allowed =
          getAllowedDepartments();


        if (allowed.includes('women')) {

          return 'women';

        }

      }


      return getDefaultDepartment();

    }


    function initializeDepartments() {

      const tabs =
        getDepartmentTabs();


      if (!tabs.length) {
        return;
      }


      changeDepartment(
        getInitialDepartment(),
        false
      );

    }


    function handleDepartmentClick(
      event
    ) {

      const link =
        event.target.closest(
          '[data-bavly-department-tab]'
        );


      if (!link) {
        return;
      }


      if (!isHomePage()) {
        return;
      }


      event.preventDefault();


      changeDepartment(

        link.getAttribute(
          'data-bavly-department-tab'
        ),

        true

      );

    }


    function handleDrawerDepartmentClick(
      event
    ) {

      const button =
        event.target.closest(
          '[data-bavly-drawer-department]'
        );


      if (!button) {
        return;
      }


      changeDepartment(

        button.getAttribute(
          'data-bavly-drawer-department'
        ),

        isHomePage()

      );

    }


    if (
      !window.__bavlyDepartmentHandlersBound
    ) {

      document.addEventListener(
        'click',
        handleDepartmentClick
      );


      document.addEventListener(
        'click',
        handleDrawerDepartmentClick
      );


      window.__bavlyDepartmentHandlersBound =
        true;

    }


    if (
      document.readyState === 'loading'
    ) {

      document.addEventListener(
        'DOMContentLoaded',
        initializeDepartments,
        {
          once: true
        }
      );

    } else {

      initializeDepartments();

    }


    document.addEventListener(
      'shopify:section:load',
      initializeDepartments
    );

  })();



  /* ==========================================================
     SIDE MENU OPEN / CLOSE
  ========================================================== */

  (function () {

    function getDrawer() {

      return document.querySelector(
        '[data-bavly-side-menu]'
      );

    }


    function getOverlay() {

      return document.querySelector(
        '[data-bavly-menu-overlay]'
      );

    }


    function getOpenButton() {

      return document.querySelector(
        '[data-bavly-menu-open]'
      );

    }


    function openDrawer() {

      const drawer =
        getDrawer();


      const overlay =
        getOverlay();


      const button =
        getOpenButton();


      if (!drawer) {
        return;
      }


      drawer.classList.add(
        'is-open'
      );


      drawer.setAttribute(
        'aria-hidden',
        'false'
      );


      if (overlay) {

        overlay.classList.add(
          'is-open'
        );

      }


      if (button) {

        button.setAttribute(
          'aria-expanded',
          'true'
        );

      }


      document.body.classList.add(
        'bv-side-menu-open'
      );


      const closeButton =
        drawer.querySelector(
          '[data-bavly-menu-close]'
        );


      if (closeButton) {

        window.setTimeout(
          function () {

            closeButton.focus();

          },
          50
        );

      }

    }


    function closeDrawer() {

      const drawer =
        getDrawer();


      const overlay =
        getOverlay();


      const button =
        getOpenButton();


      if (!drawer) {
        return;
      }


      drawer.classList.remove(
        'is-open'
      );


      drawer.setAttribute(
        'aria-hidden',
        'true'
      );


      if (overlay) {

        overlay.classList.remove(
          'is-open'
        );

      }


      if (button) {

        button.setAttribute(
          'aria-expanded',
          'false'
        );

      }


      document.body.classList.remove(
        'bv-side-menu-open'
      );

    }


    function handleClick(
      event
    ) {

      if (
        event.target.closest(
          '[data-bavly-menu-open]'
        )
      ) {

        openDrawer();

        return;

      }


      if (
        event.target.closest(
          '[data-bavly-menu-close]'
        )
      ) {

        closeDrawer();

        return;

      }


      if (
        event.target.matches(
          '[data-bavly-menu-overlay]'
        )
      ) {

        closeDrawer();

      }

    }


    function handleKeydown(
      event
    ) {

      if (
        event.key === 'Escape'
      ) {

        closeDrawer();

      }

    }


    if (
      !window.__bavlyDrawerBound
    ) {

      document.addEventListener(
        'click',
        handleClick
      );


      document.addEventListener(
        'keydown',
        handleKeydown
      );


      window.__bavlyDrawerBound =
        true;

    }

  })();


  } catch(e) { console.error(e); }
})();
})();
